/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_OnlineInputs */

const en_directory_vibebids_online = /** @type {(inputs: Directory_Vibebids_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} online`)
};

const zh_directory_vibebids_online = /** @type {(inputs: Directory_Vibebids_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 人在线`)
};

/**
* | output |
* | --- |
* | "{count} online" |
*
* @param {Directory_Vibebids_OnlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_online = /** @type {((inputs: Directory_Vibebids_OnlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_OnlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_online(inputs)
	return zh_directory_vibebids_online(inputs)
});
export { directory_vibebids_online as "directory.vibebids.online" }